/**
 * @voltxampere/ui — 25LC080 SPI EEPROM (Sprint 45-5, placeholder)
 *
 * PLACEHOLDER. SPI bus simulation Sprint 47+ engine extension #4
 * ile aktif olur. Şu anki davranış `digital-gate` placeholder.
 *
 * Reference: Microchip 25LC080 — DIP-8 / SOIC-8. SPI EEPROM, 8
 * Kbit (1 KByte), V_DD 1.8-5.5 V, write cycle 5 ms, clock 10 MHz
 * max. ID/serial number storage, lookup table, küçük config blob.
 *
 *   Default mapping → digital-gate schemaType:
 *     gateFunction = "NOT"
 *     propagationDelay = 100e-9  (100 ns SPI response)
 *
 * Engine zero-diff invariant honored — canonical `digital-gate`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const memory25lc080 = {
    id: "25lc080",
    nameTr: "25LC080 (SPI EEPROM 8Kbit, DIP-8, placeholder)",
    nameEn: "25LC080 (SPI EEPROM 8Kbit, DIP-8, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "25LC080",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 100e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=memory-25lc080.js.map